import { IconChevronRight16, IconFavorite24 } from '@fabric-ds/icons/react';
import { trackHotelFavoriteLink } from './tracking';

type HotelFavoriteLinkProps = {
    favoriteHotelCount: number;
};

export const HotelFavoriteLink = ({ favoriteHotelCount }: HotelFavoriteLinkProps) =>
    favoriteHotelCount ? (
        <div className="bg-aqua-50 rounded-8 p-16 sm:px-32 mt-16" data-testid="hotelFavoriteLink">
            <IconFavorite24 className="align-middle mr-16 inline-block" />
            <span className="align-middle" data-testid="numberOfFavoriteHotels">
                Du har {favoriteHotelCount} {favoriteHotelCount > 1 ? 'lagrede favoritter' : 'lagret favoritt'}
            </span>
            <a
                onClick={trackHotelFavoriteLink}
                data-testid="hotelFavoriteLinkLink"
                className="font-bold inline-block ml-16 px-16 py-8"
                href="/reise/hotell/favoritter">
                <span className="align-middle" data-testid="hotelFavoriteLinkText">
                    Gå til {favoriteHotelCount > 1 ? 'favoritthotellene dine' : 'favoritthotellet ditt'}
                </span>
                <IconChevronRight16 className="align-middle ml-8 inline-block" />
            </a>
        </div>
    ) : null;
